import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const OPEN_CYCLE_ONLY_SCHEDULED_ORDERS_DEV_ONLY = true;

export let isOpenCycleOnlyScheduledOrdersEnabled = false;

// Regra TEMPORÁRIA (deve cair no futuro): as telas de pedidos programados abrem somente no ciclo aberto,
// sem o seletor de ciclos em cards; os demais ciclos são consultados pelo filtro "Ciclo do pedido".
// DESATIVADA (20/10): voltou o seletor de ciclos no topo das telas e o filtro "Ciclo do pedido" saiu.
// Para ligar de novo, descomente a linha abaixo (ou remova esta feature e o filtro por completo).
// isOpenCycleOnlyScheduledOrdersEnabled = !OPEN_CYCLE_ONLY_SCHEDULED_ORDERS_DEV_ONLY || isDevelopmentEnvironment;
